// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * This theme is an example to show how you can add triangles to the dropdowns.
 */
.triangle-theme .pika-label:after {
    content:" \\25be";
}
`, "",{"version":3,"sources":["webpack://./local_modules/pikaday/css/triangle.css"],"names":[],"mappings":"AAAA;;EAEE;AACF;IACI,gBAAgB;AACpB","sourcesContent":["/**\r\n * This theme is an example to show how you can add triangles to the dropdowns.\r\n */\r\n.triangle-theme .pika-label:after {\r\n    content:\" \\25be\";\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
